import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Participant as TParticipant, YesNo } from 'types/global'
import Margin from 'components/Margin'
import Button from 'components/Button'
import { setEntegralParticipant } from 'redux/slices/kongSlice'
import Participant from './Participant'
import { Props } from './Results'
import { useDispatch } from 'react-redux'
import { updateLocation } from 'redux/location/locationSlice'
import { MarkerType } from 'types/googleMaps'
import { Flex } from 'components/primitives'
import styled from 'styled-components/macro'
import { MdCheckCircle } from 'react-icons/md'
import { palette } from 'styled-tools'
import { pxToRem } from 'theme/utils'

export const AfterHoursDropAcceptedText = styled.span`
  color: ${palette('calypso')};
  font-weight: 700;
`

export const AfterHoursDropAcceptedIcon = styled(MdCheckCircle)`
  color: ${palette('mountainMeadow')};
  margin-right: ${pxToRem(4)};
  min-width: ${pxToRem(24)};
`

type ParticipantItemProps = {
  participant: TParticipant
  outOfNetwork?: boolean
} & Props

const ParticipantItem: React.FC<ParticipantItemProps> = ({ network, onSetAssignment, participant, outOfNetwork }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <>
      <Participant participant={participant} network={network} outOfNetwork={outOfNetwork} showHours={true} />
      {participant.properties?.afterHoursDrop?.toUpperCase() === YesNo.YES && (
        <Margin spacing="md">
          <Flex
            style={{
              alignItems: 'center',
            }}
          >
            <AfterHoursDropAcceptedIcon />
            <AfterHoursDropAcceptedText>{t('network.afterHoursDropAccepted')}</AfterHoursDropAcceptedText>
          </Flex>
        </Margin>
      )}
      <Margin spacing="md">
        <Button.Primary
          style={{ width: '100%' }}
          onClick={() => {
            dispatch(setEntegralParticipant(participant))
            onSetAssignment && onSetAssignment(participant)
            const [streetNumber, street] = participant.entity.address!.addressLine1!.split(' ')

            const addressDescription = [
              `${participant.entity.name}<br/>`,
              participant.entity.address!.addressLine1!,
              `${participant.entity.address!.city} ${participant.entity.address!.administrativeArea}`,
              participant.entity.address!.postalCode,
              participant.entity.address!.country,
            ]
            dispatch(
              updateLocation({
                name: 'vehicleDestinationLocation',
                location: {
                  latitude: participant.location!.latitude!,
                  longitude: participant.location!.longitude!,
                  address: {
                    city: participant.entity.address!.city!,
                    country: participant.entity.address!.country!,
                    countryShortCode: participant.entity.address!.country!,
                    postalCode: participant.entity.address!.postalCode!,
                    state: participant.entity.address!.administrativeArea!,
                    street,
                    streetNumber,
                  },
                  ...participant,
                  addressDescription: addressDescription.join(', '),
                  serviceLocationType: MarkerType.VEHICLEDESTINATION,
                },
              }),
            )
          }}
        >
          {t('network.setDestination')}
        </Button.Primary>
      </Margin>
    </>
  )
}

export default ParticipantItem
